import { h, render } from 'preact';

import { preactWidget } from '../../utils';
import widgetParselyMyTeam from '../parsely-my-team/widget-config';
import widgetParselyMySport from '../parsely-my-sport/widget-config';
import widgetParselyMyLocalNews from '../parsely-my-local-news/widget-config';
import widgetNewsletter from '../newsletter/widget-config';

import { UserPreferencesComponent } from './component';
import widget from './widget-config';

export const hydrate = () => {
  const { $root } = preactWidget(widget);
  const htmlProps = window.SkyPreferencesSettings || { blocks: [] };
  render(
    <UserPreferencesComponent
      htmlProps={htmlProps}
      widget={widget}
      widgetParselyMyTeam={widgetParselyMyTeam}
      widgetParselyMySport={widgetParselyMySport}
      widgetParselyMyLocalNews={widgetParselyMyLocalNews}
      widgetNewsletter={widgetNewsletter}
      $root={$root}
    />,
    $root
  );
};
